var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloggerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blogger-logo_svg__blogger-clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8 14.8H6.65c-.67 0-1.21-.55-1.21-1.2 0-.66.54-1.2 1.21-1.2h7.15c.66 0 1.2.54 1.2 1.2 0 .65-.54 1.2-1.2 1.2zM6.65 5.17h3.52c.67 0 1.21.54 1.21 1.2 0 .66-.54 1.2-1.21 1.2H6.65c-.67 0-1.21-.54-1.21-1.2 0-.66.54-1.2 1.21-1.2zm13.08 2.57c-.43-.18-2.24.02-2.74-.44-.36-.32-.38-.92-.52-1.7a7.15 7.15 0 00-.57-2.15C15.02 1.59 12.92 0 11 0H6.58A6.35 6.35 0 00.24 6.32v7.37C.24 17.16 3.09 20 6.57 20h7.29a6.35 6.35 0 006.34-6.3l.04-5.11s0-.63-.51-.85z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blogger-logo_svg__blogger-clip0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.24)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgBloggerLogo;